"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("@fontsource/inter");
const client_1 = require("react-dom/client");
const Widget_1 = __importDefault(require("./Widget"));
const domNode = document.getElementById("widget");
const uuid = domNode === null || domNode === void 0 ? void 0 : domNode.getAttribute("data-uuid");
const brandId = domNode === null || domNode === void 0 ? void 0 : domNode.getAttribute("data-brand-id");
if (domNode !== null) {
    const root = (0, client_1.createRoot)(domNode);
    if (uuid && brandId) {
        root.render(react_1.default.createElement(Widget_1.default, { uuid: uuid, brandId: brandId }));
        // root.render(<Pricing uuid={uuid} selectedDate="2024-7-31" paxCount={5} duration={4} selectedTime="04:00"  />);
    }
}
